import { DataResults } from '../data';
import { HTTPMethod } from './common.types';

export type ProviderParams = Record<string, string[] | null>;

export type DataProvider = {
  providerParams?: ProviderParams;
  endpoint: string;
  requestMethod?: HTTPMethod;
};

export enum DataMode {
  isProvider = 'isProvider',
  takeFromProvider = 'takeFromProvider',
  isPresent = 'isPresent',
}

export enum SortingDisplayLevel {
  atProvider = 'atProvider',
  atContent = 'atContent',
}

export enum SortingLocation {
  onBrowser = 'onBrowser',
  onServer = 'onServer',
}

export type SortingOptions = {
  displayLevel: SortingDisplayLevel;
  sortLocation?: SortingLocation;
};

export type DataOptions = {
  mode: DataMode;
  providerInfo?: DataProvider;
  data?: DataResults;
  sorting?: SortingOptions;
};
